module.exports = new __parcel__URL__("collaborate-on-code.0bf33caa.svg").toString();